import { Box, CircularProgress, IconButton } from "@mui/material";
import ModalComponent from "../../../Components/ModalComponent";
import { useRef, useState } from "react";
import Cookies from 'js-cookie'
import http from '../../../api/axiosInstance';
import { enqueueSnackbar } from "notistack";

function ChangePicsModal({ changePics, setChangePics }) {

    const fileRef = useRef()
    const [uploadedImg, setUploadedImg] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleSelectImg = (e) => {
        setUploadedImg(e.target.files[0]);
        console.log("🚀 ~ handleUpload ~ e.target.files[0]:", e.target.files[0])
    }

    const handleDeleteImg = () => {
        setUploadedImg(null)
    }

    const handleUpload = async () => {
        setLoading(true)

        let formDate = new FormData()

        formDate.append('file', uploadedImg)

        try {
            const response = await http({
                url: "/upload-default-property-image",
                method: "POST",
                data: formDate,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log("handleUpload", response)

            if (response?.status) {
                const variant = 'success'
                enqueueSnackbar('عکس با موفقیت آپلود شد', { variant });
                setChangePics(false)
            }


        } catch (e) {
            console.error(e);
        }

        setLoading(false)
    }

    return (
        <ModalComponent showModalState={changePics}
            handleModalClose={() => setChangePics(false)}
            modalTitle=""
            disableSubmitBtn={false}
            hasSpecificParent={true}
            modalSubmitBtn={handleUpload}
            modalTitleSubmitBtn={loading ? <CircularProgress color="inherit" /> : "آپلود تصویر"}>
            <Box sx={{ px: "50px" }} className="text-gray">
                <Box sx={{ textAlign: "center", fontSize: "15px", }}>
                    تصویر پیش فرض ملک های خود را بارگذاری کنید
                </Box>
                <Box onClick={() => fileRef?.current?.click()} sx={{ backgroundColor: "#F0F9EA", borderRadius: "4px", p: "16px", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "10px", mt: "30px", cursor: "pointer" }}>
                    {!uploadedImg ? <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "10px", }}>
                        <img src="/assets/img/upload.png" alt="" />
                        انتخاب تصویر
                    </Box> :
                        <Box sx={{ width: "100px", height: "100px", position: "relative", "& img": { width: "100%", height: "100%" } }}>
                            <IconButton sx={{ position: "absolute", zIndex: "2", width: "40px" }} onClick={handleDeleteImg}><img src='/assets/img/icons8-delete-48.png' /></IconButton>
                            <img src={URL.createObjectURL(uploadedImg)} alt="" />
                        </Box>}
                    <input type="file" className="d-none" ref={fileRef} onChange={(e) => handleSelectImg(e)} />
                </Box>
                <Box sx={{ fontSize: "12px", mt: 2 }}>
                    <Box>
                        فرمت عکس باید png باشد و در حالت transparent (بکگراند نداشته باشد).
                    </Box>
                    <Box>نسبت عکس باید 1:1 باشد.</Box>
                    <Box>اندازه عکس نهایت 150*150 باشد.</Box>
                </Box>
            </Box>
        </ModalComponent>
    );
}

export default ChangePicsModal;